/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';
import { Individu } from '@/types';

const validationRecensement = (data: Partial<Individu>) => {
  const errors = {
    nombreEnfants: '',
    nombreFreresSoeurs: '',
  };

  if (_.isNil(data?.nombreEnfants) || data?.nombreEnfants < 0) {
    errors.nombreEnfants = 'Le nombre d\'enfants à charge doit être supérieur ou égal à 0';	
  }

  if (_.isNil(data?.nombreFreresSoeurs) || data?.nombreFreresSoeurs < 0) {
    errors.nombreFreresSoeurs = 'Le nombre de frères et soeurs vivants doit être supérieur ou égal à 0';	
  }

  return _.pickBy(errors, (value) => value !== '');
};

export default validationRecensement;
